import { useContext, useMemo } from 'react';
import { ActiveApplicationContext, UserApplicationsContext } from './UserApplicationsContext';

export function useActiveApplicationIdentifier() {
  return useContext(ActiveApplicationContext);
}

export function useActiveApplication() {
  const activeApplicationIdentifier = useContext(ActiveApplicationContext);
  const userApplications = useContext(UserApplicationsContext);

  return useMemo(() => {
    // Flatten all applications from all brands
    const allApplications = Object.values(userApplications).flat();
    return allApplications.find(app => app.identifier === activeApplicationIdentifier) || null;
  }, [activeApplicationIdentifier, userApplications]);
}
